import _t from 'i18n!nls/unified-common';

export const DEADLINE_TYPES = {
  priorityDeadline: 'priorityDeadline',
  subtermDeadline: 'subtermDeadline',
  extendedSubtermDeadline: 'extendedSubtermDeadline',
  upcomingAdmissions: 'upcomingAdmissions',
  noUpcomingAdmissions: 'noUpcomingAdmissions',
  openAdmissionsNoDeadline: 'openAdmissionsNoDeadline',
  performanceBasedAdmission: 'performanceBasedAdmission',
  pbaUpcomingAdmissions: 'pbaUpcomingAdmissions',
} as const;

export type DeadlineCopy = {
  header?: string;
  body: string;
};

export const getDeadlineCopyForDegreeCard = (
  deadlineType: keyof typeof DEADLINE_TYPES,
  date: string | null
): DeadlineCopy => {
  const copy = {
    priorityDeadline: {
      body: _t('Application due #{priorityDeadlineDate}', { priorityDeadlineDate: date }),
    },
    subtermDeadline: {
      body: _t('Due #{subtermDeadlineDate}', { subtermDeadlineDate: date }),
    },
    extendedSubtermDeadline: {
      body: _t('Due #{extendedSubtermDeadlineDate}', { extendedSubtermDeadlineDate: date }),
    },
    upcomingAdmissions: {
      body: _t('Due #{admissionStartDate}', { admissionStartDate: date }),
    },
    pbaUpcomingAdmissions: {
      body: _t('Due #{admissionStartDate}', { admissionStartDate: date }),
    },
    noUpcomingAdmissions: {
      body: _t('Application deadline to be announced'),
    },
    openAdmissionsNoDeadline: {
      body: _t('Applications now open'),
    },
    performanceBasedAdmission: {
      body: _t('Due #{subtermDeadlineDate}', { subtermDeadlineDate: date }),
    },
  } as const;

  return copy[deadlineType as keyof typeof copy];
};
